import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/axios";

const Logout = () => {
    const navigate = useNavigate();
    const totalSeconds = 10; // countdown duration
    const [countdown, setCountdown] = useState(totalSeconds);

    // Call backend logout
    const logoutFromBackend = async () => {
        try {
          await axios.post("/auth/log-out", {}, { withCredentials: true }); // POST to /api/v1/auth/log-out
          // Clear frontend storage if needed
          localStorage.removeItem("auth");
        } catch (error) {
          console.error("Logout failed:", error);
          // You could still continue to show logout page
        }
    };

  useEffect(() => {
    // Perform backend logout once
    logoutFromBackend();

    // Set up countdown interval
    const interval = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // Redirect to login when countdown reaches 0
    if (countdown <= 0) {
      navigate("/login");
    }
  }, [countdown, navigate]);

  // Progress bar width calculation
  const progressPercent = ((totalSeconds - countdown) / totalSeconds) * 100;

  const handleLoginAgain = () => {
    navigate("/login"); // Immediate login
  };

  return (
    <div className="Register">
      <div className="login-card">
        <h1 style={styles.heading}>You have logged out</h1>
        <p style={styles.text}>
          Redirecting to login page in <strong>{countdown}</strong> second
          {countdown !== 1 ? "s" : ""}.
        </p>

        {/* Progress bar */}
        <div style={styles.progressBackground}>
          <div style={{ ...styles.progressBar, width: `${progressPercent}%` }} />
        </div>

        <button style={styles.button} onClick={handleLoginAgain}>
          Log In Again
        </button>
      </div>
    </div>
  );
};

// Inline styles
const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f0f2f5",
  },
  card: {
    backgroundColor: "white",
    padding: "40px",
    borderRadius: "12px",
    boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
    textAlign: "center",
    width: "320px",
  },
  heading: {
    color: "#333",
    marginBottom: "15px",
  },
  text: {
    color: "#666",
    marginBottom: "20px",
  },
  progressBackground: {
    width: "100%",
    height: "8px",
    backgroundColor: "#ddd",
    borderRadius: "4px",
    marginBottom: "30px",
    overflow: "hidden",
  },
  progressBar: {
    height: "100%",
    backgroundColor: "#4a90e2",
    borderRadius: "4px",
    transition: "width 1s linear",
  },
  button: {
    backgroundColor: "#4a90e2",
    color: "white",
    padding: "12px 25px",
    border: "none",
    borderRadius: "6px",
    fontSize: "16px",
    cursor: "pointer",
  },
};

export default Logout;